export interface Template {
  id: string
  name: string
  externalName: string
}

export interface TemplateRelation {
  id: string
  name: string
  relatives: TemplateRelationRelative[]
}

interface TemplateRelationRelative {
  id: string
  name: string
  externalName: string
}

export interface Amount {
  value: number
  currency: string
}

export enum WeekDay {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export enum PaymentFrequencyType {
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

interface YearlyPaymentFrequency {
  type: PaymentFrequencyType.YEARLY
  dayOfYear: number
}

interface MonthlyPaymentFrequency {
  type: PaymentFrequencyType.MONTHLY
  dayOfMonth: number
}

interface WeeklyPaymentFrequency {
  type: PaymentFrequencyType.WEEKLY
  dayOfWeek: WeekDay
}

interface DailyPaymentFrequency {
  type: PaymentFrequencyType.DAILY
}

export type PaymentFrequency = YearlyPaymentFrequency | MonthlyPaymentFrequency | WeeklyPaymentFrequency | DailyPaymentFrequency

export interface SubscriptionFee {
  paymentFrequency: PaymentFrequency | undefined
  isOverridden: boolean
  subscriptionFee: Amount
}
